function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

function isInvalid(obj) {
  const emptyFields = Object.values(obj).some(value => value === '' || value === null || value === undefined);

  if (emptyFields) {
    return 'Empty fields are not allowed';
  }

  // check valid email
  if (!isValidEmail(obj.email)) {
    return 'Invalid email';
  }

  return false;
}

document.addEventListener('DOMContentLoaded', () => {
  const forms = document.querySelectorAll('[data-program-key-takeaways-form]');
  if (!forms.length) return;

  forms.forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const formButton = form.querySelector('button[type="submit"]');
      formButton.disabled = true;
      formButton.innerHTML = 'Submitting...';

      const formData = new FormData(form);

      const data = Object.fromEntries(formData);
      const apiUrl = data.api_url;
      const apiAction = new URL(apiUrl).searchParams.get('action');
      
      formData.delete('api_url');

      const error = isInvalid(data);

      if (error) {
        alert(error);

        formButton.disabled = false;
        formButton.innerHTML = 'Submit';
        return;
      }

      try {
        const response = await fetch(apiUrl, {
          method: 'POST',
          body: formData,
        });

        const responseData = await response.json();

        if (responseData.error) {
          alert(responseData[apiAction]);
        } else {
          alert('Thank you for your feedback');
        }

        formButton.disabled = false;
        formButton.innerHTML = 'Submit';
      } catch (error) {
        console.error(error);
        alert('Sorry, an error occurred');
      }
    });
  });
});